import { CopyIcon } from '@p2p/assets/svg';
import { CopyText, Typography } from '@p2p/components';

import styles from './PaymentId.module.scss';
import { PaymentIdProps } from './PaymentId.types';

export const PaymentId = ({ id }: PaymentIdProps) => {
  return (
    <div className={styles.wrapper}>
      <CopyText text={id}>
        <div className={styles.container}>
          <CopyIcon className={styles.icon} />
          <Typography variant="text-m-bold" color="heading" className={styles.idText}>
            ID оплаты:
          </Typography>
          <Typography variant="text-m-bold" color="global-orange" className={styles.id}>
            {id}
          </Typography>
        </div>
      </CopyText>
    </div>
  );
};
